import { TimeINTimeOUTTypes } from '../ActionTypes/TimeINTimeOUTTypes'

let initialSate = {
    TimeText: 'Time In',
    StartTime: null,
    BreakText: 'Break In',
    BreakTime: null,
    Play: false,
    Break: false,
    datamessage: null,
    pickImage: null,
    lunchAfterImage: null
};

const TimeINTimeOUTReducer = (state = initialSate, action) => {
    switch (action.type) {

        case TimeINTimeOUTTypes.TIME_IN:
            state = { ...state, StartTime: action.payload };
            break;

        case TimeINTimeOUTTypes.TIME_OUT:
                state = { ...state, StartTime: action.payload };
                break;

        case TimeINTimeOUTTypes.WORK_TIME_IN:
            state = { ...state, TimeText: action.payload };
            break;

        case TimeINTimeOUTTypes.WORK_TIME_OUT:
                state = { ...state, TimeText: action.payload };
                break;

        case TimeINTimeOUTTypes.BREAK_TIME_IN:
                state = { ...state, BreakText: action.payload };
                break;

        case TimeINTimeOUTTypes.BREAK_TIME_OUT:
                state = { ...state, BreakText: action.payload };
                break;

        case TimeINTimeOUTTypes.PLAY:
                state = { ...state, Play: action.payload };
                break;

        case TimeINTimeOUTTypes.BREAK:
                state = { ...state, Break: action.payload };
                break;

        case TimeINTimeOUTTypes.BREAK_IN:
                state = { ...state, BreakTime: action.payload };
                break;

        case TimeINTimeOUTTypes.BREAK_OUT:
                state = { ...state, BreakTime: action.payload };
                break;

        case TimeINTimeOUTTypes.DATA_MESSAGE:
                state = { ...state, datamessage: action.payload };
                break;

        case TimeINTimeOUTTypes.TIME_IN_IMAGE:
                state = { ...state, pickImage: action.payload };
                break;

        case TimeINTimeOUTTypes.LUNCH_AFTER_IMAGE:
                state = { ...state, lunchAfterImage: action.payload };
                break;

        default:
            break;
    }
    return state;
};

export default TimeINTimeOUTReducer;